import { http } from "@/shared/lib/api/http"
import type { FinanceHomeOverview, MembersHomeOverview } from "@ibada/shared-types/overview"

/** ADR-0003 success envelope. */
type Envelope<T> = { data?: T | null }

export type FinanceHomeQuery = {
  workspaceId: string
  branchId: string
  dateFrom: string
  dateTo: string
  /** How many weeks the series covers; the server default when omitted. */
  weeks?: number
}

/** Four spending lines fit the tile at its desktop height; the rest is summed as "other". */
const SPENDING_CATEGORY_LIMIT = 4

export type MembersHomeQuery = {
  workspaceId: string
  branchId: string
}

/** `GET /finance/overview/home`: the treasury and spending tiles. Disclosure is decided server-side. */
export async function fetchFinanceHome(query: FinanceHomeQuery): Promise<FinanceHomeOverview> {
  const response = await http.get<Envelope<FinanceHomeOverview>>("/finance/overview/home", {
    params: { ...query, categoryLimit: SPENDING_CATEGORY_LIMIT },
  })
  const data = response.data?.data
  if (!data) throw new Error("Finance home overview: empty response")
  return data
}

/** `GET /members/overview/home`: the members, visitors, birthdays and new members tiles. */
export async function fetchMembersHome(query: MembersHomeQuery): Promise<MembersHomeOverview> {
  const response = await http.get<Envelope<MembersHomeOverview>>("/members/overview/home", { params: query })
  const data = response.data?.data
  if (!data) throw new Error("Members home overview: empty response")
  return data
}
